import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { DocumentTitle } from '@yakoffice/shared-components';
import { ProjectTheme } from '@yakoffice/project-theme';
import { ProjectUsers } from './projectUsers';

export const ProjectUsersIndex: FC = observer(() => {

    DocumentTitle('Projects - Portal');

    return <ProjectTheme>
        <ProjectUsers />
    </ProjectTheme>;
});

export default ProjectUsersIndex;

